import { TimecardRecord } from './TimecardRecord.model';

export class EmployeeRecord {
	pk: string; //venueKey
	sk: string; //EMPLOYEE_{employeeId}
	id: number;

	firstName: string;
	lastName: string;
	nickName: string;
	accessCode: string;
	id1: string;
	id2: string;
	birthdate: string;
	language: number;

	email: string;
	phone: string;
	address: string;
	city: string;
	state: string;
	postalCode: string;

	active: boolean = true;
	status: string = EmployeeStatus.ACTIVE;

	emergencyContactName: string;
	emergencyContactPhone: string;

	hireDate: string;
	created: string;
	lastRaise: string;
	certification1: string;
	certification2: string;

	clockInOutOnly: boolean;
	enforceScheduling: boolean;
	extendRights: boolean;
	fingerprintClockIn: boolean;
	fingerprintRequired: boolean;
	requireCard: boolean;

	w4Allowances: number;
	w4Status: number;

	jobs: EmployeeJob[];
	skills: EmployeeSkill[];

	timecards: TimecardRecord[];

	job1: string;
	statusIcon: any; //either a fa reference or the full fa property ['type','icon']

	public constructor(init?: Partial<EmployeeRecord>) {
		Object.assign(this, init);
	}
}

export class EmployeeJob {
	id: number;
	position: number;
	payRate: number;
	name?: string;
	laborGroup?: string;

	public constructor(init?: Partial<EmployeeJob>) {
		Object.assign(this, init);
	}
}

export class EmployeeSkill {
	id: number;
	skillLevel: number;

	public constructor(init?: Partial<EmployeeSkill>) {
		Object.assign(this, init);
	}
}

export enum EmployeeLanguage {
	ENGLISH = 0,
	SPANISH = 1,
}

export enum EmployeeStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	TERMINATED = 'terminated',
}

// {
//     "AccessCode": "9854",
//     "Address": "48 WATERWORKS WAY",
//     "BartenderCardDate": "12/30/1899",
//     "BirthDate": "11/22/2001",
//     "City": "Irvine",
//     "ClockInOutOnly": "False",
//     "EmergencyContact": "Service Team",
//     "EmergencyPhone": "(949) 336-7500",
//     "EnforceScheduling": "False",
//     "ExtendRights": "True",
//     "FingerprintAtClockIn": "False",
//     "FingerprintRequired": "False",
//     "FirstName": "Focus",
//     "FoodHandlerCertDate": "12/30/1899",
//     "HireDate": "11/22/2001",
//     "ID": "1",
//     "ID1": "111-11-1111",
//     "ID2": "36139033029994756",
//     "Jobs": {
//         "Job": [
//             {
//                 "ID": "64",
//                 "Position": "1",
//                 "Rate": "0.00"
//             },
//             {
//                 "ID": "8",
//                 "Position": "3",
//                 "Rate": "14.00"
//             }
//         ]
//     },
//     "Language": "0",
//     "LastName": "zzPOS",
//     "LastRaiseDate": "11/22/2001",
//     "NickName": "FocusPOS",
//     "Phone1": "(949) 556-3722",
//     "Picture": "",
//     "RequireCard": "False",
//     "Skills": {
//         "Skill": [
//             {
//                 "ID": "1",
//                 "Level": "1"
//             },
//             {
//                 "ID": "2",
//                 "Level": "1"
//             },
//             {
//                 "ID": "3",
//                 "Level": "1"
//             },
//             {
//                 "ID": "4",
//                 "Level": "1"
//             },
//             {
//                 "ID": "5",
//                 "Level": "1"
//             },
//             {
//                 "ID": "6",
//                 "Level": "1"
//             },
//             {
//                 "ID": "7",
//                 "Level": "1"
//             },
//             {
//                 "ID": "8",
//                 "Level": "1"
//             },
//             {
//                 "ID": "9",
//                 "Level": "1"
//             },
//             {
//                 "ID": "10",
//                 "Level": "1"
//             },
//             {
//                 "ID": "11",
//                 "Level": "1"
//             },
//             {
//                 "ID": "12",
//                 "Level": "1"
//             },
//             {
//                 "ID": "13",
//                 "Level": "1"
//             },
//             {
//                 "ID": "14",
//                 "Level": "1"
//             },
//             {
//                 "ID": "15",
//                 "Level": "1"
//             },
//             {
//                 "ID": "16",
//                 "Level": "1"
//             },
//             {
//                 "ID": "17",
//                 "Level": "1"
//             },
//             {
//                 "ID": "18",
//                 "Level": "1"
//             },
//             {
//                 "ID": "19",
//                 "Level": "1"
//             }
//         ]
//     },
//     "State": "CA",
//     "W4Allowances": "1",
//     "W4Status": "0",
//     "ZipCode": "92618"
// },
